import React from 'react';
import { createCustomLegendPlugin } from './customLegendPlugin';
export function useChartjsCustomLegend() {
    const [datasetsProperties, setDatasetsProperties] = React.useState([]);
    const datasetsPropertiesRef = React.useRef(datasetsProperties);
    const customLegendPlugin = React.useMemo(() => (createCustomLegendPlugin({
        doHideLegend: true,
        getDatasetsProperties: () => datasetsPropertiesRef.current,
        setDatasetsProperties: (newDatasetsProperties) => {
            datasetsPropertiesRef.current = newDatasetsProperties;
            setDatasetsProperties(newDatasetsProperties);
        },
    })), []);
    return { datasetsProperties, customLegendPlugin };
}
//# sourceMappingURL=useChartjsCustomLegend.js.map